export default "__VITE_ASSET__a872554a__"